import Reveal from "@/components/Reveal";
import SaporiSlider from "@/components/SaporiSlider";
import { useLang } from "@/i18n";

const SaporiSection = () => {
  const { t } = useLang();
  const s = t.sapori;

  return (
    <section id="sapori" className="bg-olive text-ivory overflow-hidden" data-testid="sapori-section">
      <SaporiSlider title={s.title} intro={s.intro} />

      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="border-t border-ivory/15">
          {s.items.map((item, i) => (
            <Reveal key={i} delay={0.05 * (i % 2)}>
              <div
                className="group grid md:grid-cols-12 gap-3 md:gap-8 py-8 md:py-10 border-b border-ivory/15"
                data-testid={`sapori-item-${i}`}
              >
                <span className="md:col-span-1 font-serif italic text-2xl md:text-3xl text-sand/60 leading-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="md:col-span-5 font-serif text-3xl md:text-4xl tracking-tight leading-[1.05] transition-transform duration-500 group-hover:translate-x-2">
                  {item.title}
                </h3>
                <p className="md:col-span-5 md:col-start-8 text-sm md:text-base font-light leading-relaxed text-ivory/70">
                  {item.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 md:mt-24 text-center">
          <p className="font-serif italic text-2xl md:text-4xl text-sand" data-testid="sapori-note">
            {s.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default SaporiSection;
